module.exports = __webpack_public_path__ + "img/logo.8079ac40.png";